import React from 'react';
import { Section } from './ui/Section';
import { Card } from './ui/Card';
import { Quote } from 'lucide-react';
import { Wildflower } from './botanical/Wildflower';
export function NewTestimonials() {
  const testimonials = [{
    quote: 'Mi nena se levantó con tos a las 2 de la mañana y supe exactamente qué hacer. En 20 minutos dormía tranquila.',
    author: 'Valeria M.',
    age: '34 años',
    location: 'Rosario, Santa Fe'
  }, {
    quote: 'Mi señora tenía una acidez terrible después de comer y en media hora estaba bien. Lo tenemos los dos en el teléfono.',
    author: 'Martín G.',
    age: '41 años',
    location: 'Córdoba Capital'
  }, {
    quote: 'El ritual nocturno de Mental Calm lo hago todas las noches y duermo como hace años no dormía. Vale cada peso.',
    author: 'Luciana P.',
    age: '29 años',
    location: 'Buenos Aires, CABA'
  }];
  return <Section className="bg-cream relative overflow-hidden py-20" data-id="element-313">
      <Wildflower className="absolute top-40 -left-20 w-80 h-80 text-moss opacity-5 blur-md pointer-events-none" aria-hidden="true" data-id="element-314" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-315">
        <h2 className="text-3xl md:text-4xl font-serif font-bold text-forest-deep text-center mb-12" data-id="element-316">
          Lo que dicen las familias que ya lo tienen
        </h2>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-317">
          {testimonials.map((t, idx) => <Card key={idx} className="p-8 bg-white shadow-sm border-sage-mist flex flex-col" data-id="element-318">
              <Quote className="w-10 h-10 text-honey-dark mb-6 opacity-60" data-id="element-319" />
              <p className="text-forest/80 italic mb-8 flex-grow leading-relaxed" data-id="element-320">
                "{t.quote}"
              </p>
              <div data-id="element-321">
                <p className="font-bold text-forest-deep" data-id="element-322">
                  {t.author}, {t.age}
                </p>
                <p className="text-sm text-forest/60" data-id="element-323">{t.location}</p>
              </div>
            </Card>)}
        </div>
      </div>
    </Section>;
}